{
  "route": "sources",
  "railEntries": [
    {
      "label": "Evidence grammar",
      "anchor": "sources-section-1"
    },
    {
      "label": "Core texts",
      "anchor": "sources-section-2"
    },
    {
      "label": "Planetary condition",
      "anchor": "sources-section-3"
    },
    {
      "label": "Transition lineages",
      "anchor": "sources-section-4"
    },
    {
      "label": "Rights & legitimacy",
      "anchor": "sources-section-5"
    },
    {
      "label": "Open questions",
      "anchor": "sources-section-6"
    }
  ],
  "anchors": [
    "sources-section-1",
    "sources-section-2",
    "sources-section-3",
    "sources-section-4",
    "sources-section-5",
    "sources-section-6"
  ],
  "nodes": [
    {
      "tag": "div",
      "attrs": {
        "class": "wrap"
      },
      "children": [
        {
          "tag": "header",
          "attrs": {
            "class": "chapter-hero"
          },
          "children": [
            {
              "tag": "div",
              "children": [
                {
                  "tag": "span",
                  "attrs": {
                    "class": "chapter-index"
                  },
                  "children": [
                    "06 · Evidence"
                  ]
                },
                " ",
                {
                  "tag": "h1",
                  "attrs": {
                    "id": "sources-title"
                  },
                  "children": [
                    "Sources, lineages & ",
                    {
                      "tag": "em",
                      "children": [
                        "honest uncertainty."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "p",
                  "attrs": {
                    "class": "chapter-deck"
                  },
                  "children": [
                    "Earth 3.0 is a synthesis, not a discovery made in isolation. This register separates your model, author propositions, verified external evidence and the new conclusions drawn between them."
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "aside",
              "attrs": {
                "class": "chapter-aside"
              },
              "children": [
                {
                  "tag": "strong",
                  "children": [
                    "Method"
                  ]
                },
                "Primary and authoritative sources were prioritised. The two supplied artifacts were analysed as authored texts; book claims were triangulated through the publisher, author and substantive interviews. Accessed August 2026."
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "div",
          "attrs": {
            "class": "chapter-body"
          },
          "children": [
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-1"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Evidence grammar"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "Four labels prevent conviction from ",
                        {
                          "tag": "em",
                          "children": [
                            "masquerading as proof."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "panel-grid four"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "evidence-label"
                          },
                          "children": [
                            "Verified source"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Externally grounded"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A claim supported by a primary or authoritative source linked here."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "evidence-label model"
                          },
                          "children": [
                            "Your model"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Authored architecture"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A definition, principle or assertion preserved from the supplied declaration."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "evidence-label proposition"
                          },
                          "children": [
                            "Author proposition"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Interpreted thesis"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A book or framework’s argument, not presented as settled empirical fact."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "evidence-label synthesis"
                          },
                          "children": [
                            "Synthesis"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "New conclusion"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "An inference produced by comparing artifacts and wider transition practice."
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-2"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Core texts"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "The three artifacts at the centre of ",
                        {
                          "tag": "em",
                          "children": [
                            "this inquiry."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "source-list"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-a1"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "A1 · SUPPLIED ARTIFACT"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Stellar & The Threshold: The Recognition"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Claude-produced interpretation commissioned before you wrote the Earth 2.0 declaration; used as the initial recognition map and visual contract."
                          ]
                        },
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "15 July 2026 · supplied HTML"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-a2"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "A2 · YOUR MODEL"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Earth 2.0: The Declaration"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Your authored mission, architecture, Threshold spine, case sequence, scale path, terms and refusals."
                          ]
                        },
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "24 July 2026 · supplied HTML"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s01"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S01 · OFFICIAL"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Stellar: A World Beyond Limits"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "RethinkX’s official report page for the technological convergence and organising-system thesis."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.rethinkx.com/publications/stellar",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open RethinkX source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s02"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S02 · OFFICIAL"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Stellar World"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "The public home of the Stellar framework and its sunrise-system framing."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://stellarworld.com/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open Stellar World ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s03"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S03 · PUBLISHER"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "I Eat the Stars"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Penguin Australia’s synopsis and publication record for Sarah Wilson’s 2026 book."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.penguin.com.au/books/i-eat-the-stars-9781761620775",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open Penguin source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s04"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S04 · INTERVIEW"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Sarah Wilson on living through collapse"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Guardian interview on interconnected collapse, local collaboration, democracy, nervous-system capacity, joy and uncertainty."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.theguardian.com/wellness/2026/jul/29/sarah-wilson-book-interview",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open Guardian interview ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S05A · AUTHOR"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Official serialisation contents"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "The four-part architecture and chapter sequence, used to contextualise the first hour of the audiobook within the complete arc."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://sarahwilson.substack.com/p/table-of-contents",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open contents ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s05"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S05 · AUTHOR"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Global publication note"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Wilson’s own framing of the book as homecoming, reckoning and communion after two years of research and writing."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://sarahwilson.substack.com/p/global-publication-day-i-eat-the",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open author note ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S05B · INTERVIEW"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Reality Studies conversation"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Extended discussion of polycrisis, planetary boundaries, sensemaking, coordination traps and the book’s personal register."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.realitystudies.co/p/sarah-wilson-i-eat-the-stars-how-to-live-fully-collapse",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open interview ↗"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-3"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Planetary condition"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "Ecological risk, resilience & ",
                        {
                          "tag": "em",
                          "children": [
                            "safe-and-just limits."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "source-list"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s06"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S06 · RESEARCH CENTRE"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Planetary Boundaries"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Stockholm Resilience Centre’s framework and 2025 status update."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.stockholmresilience.org/research/planetary-boundaries.html",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s07"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S07 · IPCC"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "AR6 Synthesis: narrowing pathways"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "IPCC synthesis figure on mitigation and development pathways as warming increases."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.ipcc.ch/report/ar6/syr/figures/summary-for-policymakers/figure-spm-6/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s08"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S08 · PEER REVIEW"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Navigating polycrisis"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Long-run evidence showing that shocks interact with popular immiseration, elite conflict and state capacity rather than mechanically producing collapse."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://royalsocietypublishing.org/rstb/article/378/1889/20220402/109358/Navigating-polycrisis-long-run-socio-cultural",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open Royal Society source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s09"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S09 · EARTH COMMISSION"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Safe and Just Earth System Boundaries"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Framework connecting biophysical stability with justice and human exposure."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://earthcommission.org/safe-and-just-earth-system-boundaries/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S10 · IPBES"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Transformative Change Assessment"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Assessment framing transformative change as shifts in views, structures and practices, with Indigenous and local knowledge integral."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://ict.ipbes.net/ipbes-ict-guide/data-and-knowledge-management/citations-of-ipbes-assessments/transformative-change-assessment",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S10B · UNDRR"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Global Assessment Report 2025"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "UNDRR analysis of systemic risk, resilience and investment choices."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.undrr.org/gar/gar2025",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-4"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Transition lineages"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "The field already knows more than ",
                        {
                          "tag": "em",
                          "children": [
                            "any one model."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "source-list"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s11"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S11 · FUTURES"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Three Horizons"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "International Futures Forum’s framework for seeing dominant, transition and emerging patterns together."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.internationalfuturesforum.com/three-horizons",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card",
                        "id": "source-s12"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S12 · SYSTEM CHANGE"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Berkana’s Two Loops"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A lineage for naming, connecting, nourishing and illuminating pioneers while hospicing the old."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://berkana.org/our-work/pioneering-a-new-paradigm/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S13 · OECD"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Innovative public participation"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Evidence and guidance on representative deliberative processes and institutionalisation."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.oecd.org/en/topics/sub-issues/open-government-and-citizen-participation/innovative-public-participation.html",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S14 · ILO"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Just Transition Guidelines"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "International labour framework for fairness, decent work and social dialogue through environmental transition."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.ilo.org/publications/guidelines-just-transition-towards-environmentally-sustainable-economies",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S15 · UNESCO"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Futures Literacy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "UNESCO capability for using multiple imagined futures to act differently in the present."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.unesco.org/en/futures-literacy",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S16 · CLIMATE-KIC"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Place-based transformations"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Portfolio and deep-demonstration practice for complex, systemic climate transition."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.climate-kic.org/programmes/place-based-transformations/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S17 · UCL IIPP"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Mission-oriented policy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Public-purpose practice for aligning institutions, investment and innovation around missions."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.ucl.ac.uk/bartlett/public-purpose/policy/mission-oriented-policy-hub",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S18 · STOCKHOLM"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Adaptive governance"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Principles for learning, polycentric coordination and governing dynamic social-ecological systems."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.stockholmresilience.org/research/insights/2016-11-16-insight-3-adaptive-governance.html",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S19 · DOUGHNUT ECONOMICS"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Social foundation, ecological ceiling"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A widely used visual and practice framework for thriving within social and planetary boundaries."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://doughnuteconomics.org/about-doughnut-economics",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S20 · REGENESIS"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Regenerative development"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Place-sourced practice focused on living systems, potential and developmental rather than extractive intervention."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://regenesisgroup.com/book",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S25 · DRIFT"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Transition management & the X-curve"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A practical bridge between build-up and breakdown: emergence and institutionalisation alongside destabilisation and phase-out."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://drift.eur.nl/en/publications/toolkit/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S26 · OECD"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Anticipatory governance"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Institutional foresight, experimentation and learning so governments can prepare for plausible futures without pretending to predict them."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.oecd.org/en/topics/anticipatory-governance.html",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S27 · PLANETARY COMMONS"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Polycentric stewardship"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Cross-scale governance for Earth-regulating systems, correcting both top-down control and isolated localism."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.stockholmresilience.org/publications/publications/2024-10-12-the-planetary-commons-a-new-paradigm-for-safeguarding-earth-regulating-systems-in-the-anthropocene.html",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S28 · RESILIENCE ALLIANCE"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Adaptive cycles & panarchy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Growth, conservation, release and reorganisation across nested scales, useful for graceful phase-out and renewal."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.resalliance.org/panarchy",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-5"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Rights & legitimacy"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "The missing layer in the original ",
                        {
                          "tag": "em",
                          "children": [
                            "six-seat room."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "source-list"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S21 · WESTERN AUSTRALIA"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Aboriginal Empowerment Strategy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "WA government strategy for Aboriginal-led decision-making, partnership and accountability."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.wa.gov.au/organisation/department-of-the-premier-and-cabinet/aboriginal-empowerment-strategy-western-australia-2021-2029",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S22 · PRODUCTIVITY COMMISSION"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Indigenous Evaluation Strategy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Principles for evaluation centred on Indigenous people, perspectives, priorities and knowledges."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.pc.gov.au/inquiries-and-research/indigenous-evaluation/strategy/",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S23 · AIATSIS"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Indigenous Data Sovereignty"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Foundational material on Indigenous governance of data, knowledge and its use."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://aiatsis.gov.au/publication/116530",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "source-card"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "source-id"
                          },
                          "children": [
                            "S24 · WALES"
                          ]
                        },
                        {
                          "tag": "h3",
                          "children": [
                            "Well-being of Future Generations Act"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "A statutory example of long-term public duties, prevention, collaboration and future-generations accountability."
                          ]
                        },
                        {
                          "tag": "a",
                          "attrs": {
                            "href": "https://www.legislation.gov.uk/anaw/2015/2/contents",
                            "target": "_blank",
                            "rel": "noreferrer"
                          },
                          "children": [
                            "Open source ↗"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "section",
              "attrs": {
                "class": "section-block",
                "id": "sources-section-6"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "section-intro"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "section-label"
                      },
                      "children": [
                        "Still unresolved"
                      ]
                    },
                    {
                      "tag": "h2",
                      "attrs": {
                        "class": "section-heading"
                      },
                      "children": [
                        "Questions the first pilot must be designed ",
                        {
                          "tag": "em",
                          "children": [
                            "to answer."
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "panel-grid three"
                  },
                  "children": [
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Legitimacy"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "When does a curated room gain authority, and when must decisions return to elected, statutory or rights-holder bodies?"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Readiness"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Which observable conditions predict durable movement, and how can readiness be built without privileging the already powerful?"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Power"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Which decision, consent, veto, funding and accountability rules actually reduce capture?"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Evidence"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "How can plural knowledge remain visible without collapsing facts, uncertainty, values and interests into “one truth”?"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Scale"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "What is invariant, what must remain locally governed and when does replication become extraction?"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "Exit"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "What observable capacity proves that stewardship can transfer without the work decaying or becoming dependent?"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "button",
              "attrs": {
                "class": "route-next",
                "type": "button",
                "data-go": "field"
              },
              "children": [
                {
                  "tag": "span",
                  "children": [
                    "Return to the synthesis"
                  ]
                },
                {
                  "tag": "span",
                  "children": [
                    "Back to The Field ↗"
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "footer",
              "attrs": {
                "class": "tiny-footer"
              },
              "children": [
                {
                  "tag": "span",
                  "children": [
                    "06 · Evidence"
                  ]
                },
                {
                  "tag": "span",
                  "children": [
                    "Version 0.1 · August 2026"
                  ]
                }
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
